import { Component, OnInit } from '@angular/core';
import { NzModalService, NzModalModule } from 'ng-zorro-antd/modal';
import { TarifarioService } from '../../../../core/services/tarifario.service';
import { EditarTarifaComponent } from '../../../../core/components/editar-tarifa/editar-tarifa.component';
import { CommonModule } from '@angular/common';
import { TablaComponent } from '../../../../core/components/tabla/tabla.component';
import { Tarifario } from '../../../../core/interfaces/utilidades/tarifario.interface';

@Component({
  selector: 'app-tarifario',
  templateUrl: './tarifario.component.html',
  styleUrls: ['./tarifario.component.css'],
  standalone: true,
  imports: [CommonModule, TablaComponent, NzModalModule]
})
export class TarifarioComponent implements OnInit {
  tarifarios: any[] = [];
  columns = [
    { title: 'Campo', key: 'campo' },
    { title: 'Institución', key: 'tipo_institucion' },
    { title: 'Tipo Día', key: 'tipo_dia' },
    { title: 'Inicio', key: 'horario_inicio' },
    { title: 'Fin', key: 'horario_fin' },
    { title: 'Tarifa por Hora', key: 'tarifa_por_hora' }
  ];

  constructor(
    private tarifarioService: TarifarioService,
    private modal: NzModalService
  ) {}

  ngOnInit(): void {
    this.loadTarifarios();
  }

  loadTarifarios(): void {
    this.tarifarioService.getAll().subscribe((data: Tarifario[]) => {
      this.tarifarios = data.map(tarifario => ({
        id_tarifa: tarifario.id_tarifa,
        campo: tarifario.campo.nombre_campo,
        tipo_institucion: tarifario.tipo_institucion.nombre_institucion,
        tipo_dia: tarifario.tipo_dia.nombre_tipo_dia,
        horario_inicio: tarifario.horario_inicio,
        horario_fin: tarifario.horario_fin,
        tarifa_por_hora: tarifario.tarifa_por_hora
      }));
      console.log('Tarifarios loaded:', this.tarifarios); // Debugging line
    });
  }

  openEditTarifaModal(tarifa: any): void {
    console.log('Editing tarifa:', tarifa); // Debugging line

    const modalRef = this.modal.create({
      nzTitle: 'Editar Tarifa',
      nzContent: EditarTarifaComponent,
      nzData: { tarifa: tarifa },
      nzFooter: null
    });

    modalRef.afterClose.subscribe((result) => {
      if (result) { // 🔹 Si `true` se pasó al cerrar, recargar tarifas
        console.log('Tarifa actualizada, recargando lista...');
        this.loadTarifarios(); // 🔹 Vuelve a cargar la lista de tarifas
      }
    });
  }

}
